import React, { useEffect, useState } from "react";
import client from "../../assets/images/Ellipse 1.png";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import "../SharedModule/SideOrderDetails.css";
import { useSelector } from "react-redux";
import { database } from "../../firebase"; 
import {
  ref,
  onValue,
} from "firebase/database";

export default function SideOrderDetails() {

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const baseUrl = "https://estbn.com/EstbnNew/public";

  const [order, setOrder] = useState([]);

  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);

  const [userPresence, setUserPresence] = useState(null);

  const [showAddressMap, setShowAddressMap] = useState(false);

  const toggleOrderModal = () => {
    setIsOrderModalOpen(!isOrderModalOpen);
  };

  const { id } = useParams();

  const getOrder = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/portal/orders/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.order);
      setOrder(response.data.data.order);
    } catch (error) {
      console.log(error.message);
    }
  };

  const modifyDate = (date) => {
    if (!date) return "-";
    const formatted = date.replace(" at ", " ");
    const d = new Date(formatted);
    if (isNaN(d)) return "-";
    return d.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const toInputDate = (date) => {
    if (!date) return "";
    const formatted = date.replace(" at ", " ");
    const d = new Date(formatted);
    if (isNaN(d)) return "";
    return d.toISOString().split("T")[0];
  };

    const getSelectedAnswerLabel = (questionKey) => {
      const question = order?.address?.saved_address?.question_answers?.find(
        (q) => q.key === questionKey,
      );
      if (!question) return "-";
      const selectedOption = question.options?.find((opt) => opt.selected);
      return selectedOption?.label || selectedOption?.value || "-";
    };

    const formatLastUsed = (date) => {
      if (!date) return "-";
      const diffDays = Math.floor(
        (new Date() - new Date(date)) / (1000 * 60 * 60 * 24),
      );
      if (diffDays <= 0) return "اليوم";
      if (diffDays === 1) return "منذ يوم";
      return `منذ ${diffDays} أيام`;
    };

  useEffect(() => {
    getOrder();
  }, [id]);

  useEffect(() => {
    const userId = order?.user?.id;
    if (!userId) return;

    const userRef = ref(database, `users/${userId}`);

    const unsub = onValue(userRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) return;
      setUserPresence(data);
    });

    return () => unsub();
  }, [order?.user?.id]);

  return (
    <>
      {isOrderModalOpen && (
        <div
          className="modal fade show"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden={isOrderModalOpen ? "false" : "true"}
          style={{ display: "block" }}
        >
          <div className="modal-dialog orderDetails-modal" role="document">
            <div className="modal-content">
              <div className="modal-header orderDetails-modalHeader px-4">
                <p className="modal-title orderDetails-modalTitle mx-3 fs-3 text-muted fw-semibold">
                  Order
                  <span className="fs-3 mx-2 fw-bolder text-dark">
                    #{order.id}
                  </span>
                </p>
                <div className="d-flex align-items-center justify-content-center">
                  <img src={`${order.order_status?.image_url}`} alt="" />
                  <p className="my-0 mx-2 fs-5 text-muted fw-semibold">
                    {order.order_status?.label}
                  </p>
                </div>
              </div>
              <div className="modal-body orderDetails-modalBody px-3 py-2">
                <div className="d-flex justify-content-between align-items-center my-2">
                  <div className="w-50 mx-2">
                    <label className="fw-semibold" htmlFor="requestedDate">
                      Requested Date
                    </label>
                    <input
                      type="date"
                      className="form-control my-2"
                      id="requestedDate"
                      value={toInputDate(order.created_at)}
                      readOnly
                    />
                  </div>
                  <div className="w-50 mx-2">
                    <label className="fw-semibold" htmlFor="Time">
                      Time
                    </label>
                    <input
                      type="text"
                      className="form-control my-2"
                      id="Time"
                      value={
                        order.scheduled_from && order.scheduled_to
                          ? `${order.scheduled_from} - ${order.scheduled_to}`
                          : "Not specified"
                      }
                      readOnly
                    />
                  </div>
                </div>
                <div className="m-2">
                  <div>
                    <label className="fw-semibold" htmlFor="location">
                      Location
                    </label>
                    <input
                      type="text"
                      className="form-control my-2"
                      id="location"
                      value={order.address?.area || ""}
                      readOnly
                    />
                  </div>
                </div>
                <div className="m-2">
                  <div className="overflow-hidden rounded-2">
                    {order.address?.latitude && order.address?.longitude ? (
                      <iframe
                        src={`https://www.google.com/maps?q=${order.address.latitude},${order.address.longitude}&output=embed`}
                        width="1000"
                        height="200"
                        loading="lazy"
                        title="Order Location Map"
                      ></iframe>
                    ) : (
                      <div className="text-muted small p-3 text-center">
                        No location available
                      </div>
                    )}
                  </div>
                </div>
                {order.comment && (
                  <div className="form-group mx-2">
                    <label htmlFor="comment" className="fw-semibold">
                      Comments
                    </label>
                    <textarea
                      className="form-control my-2"
                      rows="5"
                      id="comment"
                      value={order.comment}
                      readOnly
                    ></textarea>
                  </div>
                )}
              </div>
              <div className="modal-footer d-flex justify-content-evenly">
                <button
                  type="button"
                  className="btn btn-dark px-0 py-2 "
                  onClick={toggleOrderModal}
                  style={{ width: "30%" }}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-outline-dark px-0 py-2"
                  onClick={toggleOrderModal}
                  style={{ width: "30%" }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="col-sm-12 col-md-4">
        <div className="order-data border border-1 rounded-2 px-3 py-4 ms-sm-0 my-sm-3 my-md-0 ms-md-2 small">
          <p className="fw-bolder fs-4">Order #{order.id}</p>
          <div className="services-card d-flex justify-content-between align-items-center">
            <div>
              <p className="my-0">Services:</p>
            </div>
            <div className="services-icons d-flex">
              {order.categories?.map((cat) => {
                return (
                  <img
                    key={cat.id}
                    src={
                      cat.icon_url?.startsWith("http")
                        ? cat.icon_url
                        : `${baseUrl}${cat.icon_url}`
                    }
                    style={{ width: "35px" }}
                    alt=""
                  />
                );
              })}
            </div>
          </div>
          <div className="d-flex justify-content-between order-nested-data">
            <p>Order Date:</p>
            <span>{modifyDate(order.created_at)}</span>
          </div>
          <div className=" d-flex justify-content-between order-nested-data">
            <p>Updated Date:</p>
            <span>{modifyDate(order.updated_at)}</span>
          </div>
          <div className=" d-flex justify-content-between order-nested-data">
            <p>Car Model:</p>
            <span>{order.vehicle?.name}</span>
          </div>
          <hr />
          <div className="d-flex justify-content-between align-items-center">
            <p className="fw-bold">Order Info</p>
            {/* <div className="services-icons">
              <i className="fa-regular fa-comment-dots fs-5 mx-3"></i>
              <i
                onClick={toggleOrderModal}
                className="fa-solid fa-pen fs-5 cursor"
              ></i>
            </div> */}
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>Requested Date:</p>
            <span>{modifyDate(order.created_at)}</span>
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>Time:</p>
            <span>
              From {order.scheduled_from} To {order.scheduled_to}
            </span>
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>Payment:</p>
            <span>{order.payment?.method?.name_en}</span>
          </div>
        </div>
        <div className="address-data border border-1 rounded-2 px-3 py-4 ms-sm-0 ms-md-2 mt-4 small">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="fs-5 fw-semibold mb-0">Address Details</p>
              <Link
              to={`/saved-addresses/edit/${order?.address?.saved_address?.id}/${order?.address?.id}`}
              className="address-edit-link cursor text-decoration-none"
              >
             Edit
            </Link>
          </div>
          <div className="d-flex align-items-start gap-3 mb-3">
            <div
              className="position-relative"
              style={{ width: "100px", height: "80px", flexShrink: 0 }}
            >
              <img
                src={
                  order?.address?.saved_address?.images?.[0]?.image_url ||
                  client
                }
                onError={(e) => {
                  e.currentTarget.src = client;
                }}
                alt=""
                className="w-100 h-100 rounded-2 object-fit-cover"
              />
              {order?.address?.saved_address?.is_default && (
                <span className="address-primary-badge position-absolute">
                  Primary
                </span>
              )}
            </div>
            <div>
              <p className="fw-semibold mb-1">
                {order?.address?.saved_address?.name ||
                  order?.address?.saved_address?.type?.label ||
                  "-"}
              </p>
              <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                {order?.address?.address}
              </p>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center order-nested-data">
            <div className="d-flex align-items-center gap-2 text-muted">
              <i className="fa-solid fa-tag"></i>
              <span>Address Name</span>
            </div>
            <span className="fw-medium">
              {order?.address?.saved_address?.name ||
                order?.address?.display_name ||
                "-"}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center order-nested-data">
            <div className="d-flex align-items-center gap-2 text-muted">
              <i className="fa-solid fa-house"></i>
              <span>Type</span>
            </div>
            <span className="fw-medium">
              {order?.address?.saved_address?.type?.label || "-"}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center order-nested-data">
            <div className="d-flex align-items-center gap-2 text-muted">
              <i className="fa-solid fa-car"></i>
              <span>Car Location</span>
            </div>
            <span className="fw-medium">
              {getSelectedAnswerLabel("car_location")}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center order-nested-data">
            <div className="d-flex align-items-center gap-2 text-muted">
              <i className="fa-solid fa-route"></i>
              <span>Access</span>
            </div>
            <span className="fw-medium">
              {getSelectedAnswerLabel("access")}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center order-nested-data">
            <div className="d-flex align-items-center gap-2 text-muted">
              <i className="fa-regular fa-clock"></i>
              <span>Last Used</span>
            </div>
            <span className="fw-medium">
              {formatLastUsed(order?.address?.saved_address?.last_usage)}
            </span>
          </div>

          {order?.address?.saved_address?.features?.length > 0 && (
            <div className="address-features-box d-flex flex-wrap justify-content-start gap-2 p-2 my-3">
              {order.address.saved_address.features.map((feature, idx) => (
                <div
                  key={idx}
                  className="address-feature-chip d-flex align-items-center gap-2 px-3 py-2 rounded-2"
                  style={{
                    backgroundColor: feature.bg_color || "#F3F4F6",
                  }}
                >
                  {feature.icon_url && (
                    <img
                      src={`${baseUrl}${feature.icon_url}`}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  )}
                  <span
                    className="fw-medium"
                    style={{
                      color: feature.text_color || "#333",
                      fontSize: "13px",
                    }}
                  >
                    {feature.label}
                  </span>
                </div>
              ))}
            </div>
          )}

          <button
            type="button"
            className="btn address-location-btn w-100 d-flex justify-content-between align-items-center"
            onClick={() => setShowAddressMap(!showAddressMap)}
          >
            <span>
              <i className="fa-solid fa-location-dot me-2"></i>
              View Location Details
            </span>
            <i
              className={`fa-solid ${
                showAddressMap ? "fa-chevron-up" : "fa-arrow-right"
              }`}
            ></i>
          </button>

          {showAddressMap &&
            order?.address?.latitude &&
            order?.address?.longitude && (
              <div className="overflow-hidden rounded-2 mt-2">
                <iframe
                  src={`https://www.google.com/maps?q=${order.address.latitude},${order.address.longitude}&output=embed`}
                  width="100%"
                  height="180"
                  loading="lazy"
                  title="Address Location Map"
                ></iframe>
              </div>
            )}
        </div>
        <div className="client-data border border-1 rounded-2 px-3 py-4 ms-sm-0 ms-md-2 mt-4 small">
          <p className=" fs-5 fw-semibold my-2">Client</p>
          <div className=" d-flex justify-content-between align-items-center">
            <div className=" d-flex justify-content-between ">
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  minHeight: "50px",
                  minWidth: "50px",
                  borderRadius: "50%",
                }}
                className="mt-1 overflow-hidden"
              >
                <img
                  style={{
                    width: "50px",
                    height: "50px",
                    minHeight: "50px",
                    minWidth: "50px",
                    borderRadius: "50%",
                  }}
                  className="object-fit-cover"
                  src={
                    order?.user?.profile_photo_path
                      ? `${baseUrl}${order.user.profile_photo_path}`
                      : client
                  }
                  onError={(e) => {
                    e.currentTarget.src = client;
                  }}
                  alt=""
                />
              </div>
              <div className=" mx-2">
                <p className="my-0 fs-6 fw-medium">{order.user?.name}</p>
                <p className=" client-birthdate text-muted fs-6">
                  <i className="fa-solid fa-cake-candles me-1"></i>
                  {order.user?.birthdate}
                </p>
              </div>
            </div>
            <div>
              <i className="fa-solid fa-chevron-right"></i>
            </div>
          </div>
          <p className=" fs-5 fw-semibold my-2">Client Info</p>
          <div className=" client-info-data">
            <p>
              <i className="fa-solid fa-phone me-2 text-muted"></i>
              {order.user?.phone_number}
            </p>
            <p>
              <i className="fa-regular fa-envelope me-2 text-muted"></i>
              {order.user?.email}
            </p>
            <p>
              <i className="fa-solid fa-car me-2 text-muted"></i>
              {order?.user?.vehicles_count} Vehicles
            </p>
            <p>
              {userPresence ? (
                userPresence.is_online ? (
                  <div className=" d-flex align-items-center gap-2">
                    <i
                      className="fa-solid fa-circle text-success"
                      style={{ fontSize: "10px" }}
                    ></i>
                    <span className="text-success fw-medium">Online</span>
                  </div>
                ) : (
                  <div className=" d-flex align-items-center gap-2">
                    <i
                      className="fa-solid fa-circle text-muted"
                      style={{ fontSize: "10px" }}
                    ></i>
                    <span className="text-muted my-0">
                      Last seen:{" "}
                      {userPresence.last_seen
                        ? new Date(userPresence.last_seen).toLocaleString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "short",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            },
                          )
                        : "-"}
                    </span>
                  </div>
                )
              ) : (
                <div className=" d-flex align-items-center gap-2">
                  <i
                    className="fa-solid fa-circle text-muted"
                    style={{ fontSize: "10px" }}
                  ></i>
                  <span className="text-muted my-0">Offline</span>
                </div>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
